import { PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { useIsVivaEngageApp } from 'hooks/useIsVivaEngageApp';
import React, { ReactNode, useCallback } from 'react';

import AppHeader from '../../AppHeader';
import AppHeaderStatic from '../../AppHeaderStatic';
import { useTeamsClientContext } from '../../TeamsClientProvider/hooks';
import VivaEngageAppHeader from '../../VivaEngageAppHeader';

type UseHeaderCallback = (collapseLeftSidebar: boolean) => (width: PageLayoutWidth | undefined) => ReactNode;
export const useHeaderCallback: UseHeaderCallback = (collapseLeftSidebar) => {
  const isVivaEngageApp = useIsVivaEngageApp();
  const { shouldHideHeaders, shouldShowStaticAppHeader } = useTeamsClientContext();

  return useCallback(
    (width) => {
      if (!width || width === PageLayoutWidth.Small || collapseLeftSidebar || shouldHideHeaders) {
        return null;
      }

      if (shouldShowStaticAppHeader) {
        return <AppHeaderStatic />;
      }

      return isVivaEngageApp ? <VivaEngageAppHeader /> : <AppHeader />;
    },
    [collapseLeftSidebar, isVivaEngageApp, shouldHideHeaders, shouldShowStaticAppHeader]
  );
};
